import React from "react";
import { useSelector } from "react-redux";
import { constants } from "@qgiv/core-js";
import * as formViews from "./constants/formViews";
import { selectRegistrationAccount } from "../../../redux/slices/registrationAccountSlice";
import WantToLogInButton from "./WantToLogInButton";

const ConnectedWantToLogInButton = () => {
    const registrationAccount = useSelector(selectRegistrationAccount);
    const {
        form: { formView },
        resetPasswordLinkStatus = "",
        urls: { donorActionUrl },
    } = registrationAccount;
    const {
        ENUMS: { Status },
    } = constants;

    // Only display the want to log in button if the reset password screen is
    // displayed and the reset password page is invalid because the reset
    // password link is used or expired display the send another link button
    const displayWantToLogInButton =
        (formView === formViews.RESET_PASSWORD &&
            resetPasswordLinkStatus === Status.USED) ||
        (formView === formViews.RESET_PASSWORD &&
            resetPasswordLinkStatus === Status.EXPIRED);

    return (
        <WantToLogInButton
            displayWantToLogInButton={displayWantToLogInButton}
            donorActionUrl={donorActionUrl}
        />
    );
};

export default ConnectedWantToLogInButton;
